import { render, staticRenderFns } from "./Cohort.vue?vue&type=template&id=c588b870&scoped=true&"
import script from "./Cohort.vue?vue&type=script&lang=js&"
export * from "./Cohort.vue?vue&type=script&lang=js&"
import style0 from "./Cohort.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Cohort.vue?vue&type=style&index=1&id=c588b870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c588b870",
  null
  
)

export default component.exports